import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=32d0a7d6&scoped=true&"
import script from "./CategoryTable.vue?vue&type=script&lang=ts&"
export * from "./CategoryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d0a7d6",
  null
  
)

export default component.exports